import React, { useEffect, useRef, useState } from 'react';

export const useShowMoreButton = (): [
  React.RefObject<HTMLDivElement | null>,
  boolean
] => {
  const targetRef = useRef<HTMLDivElement | null>(null);
  const [shouldShowButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkShowButton = () => {
      const el = targetRef.current;
      if (!el) return;
      const showButton = el.scrollHeight > el.clientHeight;
      setShowButton(showButton);
    };

    checkShowButton();

    window.addEventListener('resize', checkShowButton);
    return () => window.removeEventListener('resize', checkShowButton);
  }, []);

  return [targetRef, shouldShowButton];
};
